// Editorial 2027 planning targets. No dates or venues are confirmed.
// A sellout does not automatically authorize or release a second-city show.
export const PRIMARY_TOUR = [
  {
    "month": "January",
    "city": "Houston",
    "state": "TX",
    "target": "JAN 16, 2027",
    "backup": "JAN 30, 2027",
    "status": "FOUNDING CITY · SOUTH",
    "active": true,
    "unlockCity": "Austin",
    "unlockDate": "JAN 23, 2027",
    "order": 1
  },
  {
    "month": "February",
    "city": "Orlando",
    "state": "FL",
    "target": "FEB 20, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Tampa",
    "unlockDate": "FEB 27, 2027",
    "order": 2
  },
  {
    "month": "March",
    "city": "Dallas",
    "state": "TX",
    "target": "MAR 20, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "San Antonio",
    "unlockDate": "MAR 27, 2027",
    "order": 3
  },
  {
    "month": "April",
    "city": "Atlanta",
    "state": "GA",
    "target": "APR 17, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Birmingham",
    "unlockDate": "APR 24, 2027",
    "order": 4
  },
  {
    "month": "May",
    "city": "Charlotte",
    "state": "NC",
    "target": "MAY 15, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Raleigh",
    "unlockDate": "MAY 22, 2027",
    "order": 5
  },
  {
    "month": "June",
    "city": "Chicago",
    "state": "IL",
    "target": "JUN 5, 2027",
    "backup": "JUN 26, 2027",
    "status": "FOUNDING CITY · NORTH",
    "active": true,
    "unlockCity": "Milwaukee",
    "unlockDate": "JUN 12, 2027",
    "order": 6
  },
  {
    "month": "July",
    "city": "Detroit",
    "state": "MI",
    "target": "JUL 17, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Cleveland",
    "unlockDate": "JUL 24, 2027",
    "order": 7
  },
  {
    "month": "August",
    "city": "Seattle",
    "state": "WA",
    "target": "AUG 21, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Portland",
    "unlockDate": "AUG 28, 2027",
    "order": 8
  },
  {
    "month": "September",
    "city": "Philadelphia",
    "state": "PA",
    "target": "SEP 18, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Baltimore",
    "unlockDate": "SEP 25, 2027",
    "order": 9
  },
  {
    "month": "October",
    "city": "New York",
    "state": "NY",
    "target": "OCT 16, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Boston",
    "unlockDate": "OCT 23, 2027",
    "order": 10
  },
  {
    "month": "November",
    "city": "Los Angeles",
    "state": "CA",
    "target": "NOV 6, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "San Diego",
    "unlockDate": "NOV 13, 2027",
    "order": 11
  },
  {
    "month": "December",
    "city": "New Orleans",
    "state": "LA",
    "target": "DEC 18, 2027",
    "backup": "TBD",
    "status": "CITY LIST OPEN",
    "active": false,
    "unlockCity": "Baton Rouge",
    "unlockDate": "DEC 19, 2027",
    "order": 12
  }
];
export const UNLOCK_TOUR = [
  {
    "month": "January",
    "city": "Austin",
    "state": "TX",
    "target": "JAN 23, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Houston",
    "order": 1
  },
  {
    "month": "February",
    "city": "Tampa",
    "state": "FL",
    "target": "FEB 27, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Orlando",
    "order": 2
  },
  {
    "month": "March",
    "city": "San Antonio",
    "state": "TX",
    "target": "MAR 27, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Dallas",
    "order": 3
  },
  {
    "month": "April",
    "city": "Birmingham",
    "state": "AL",
    "target": "APR 24, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Atlanta",
    "order": 4
  },
  {
    "month": "May",
    "city": "Raleigh",
    "state": "NC",
    "target": "MAY 22, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Charlotte",
    "order": 5
  },
  {
    "month": "June",
    "city": "Milwaukee",
    "state": "WI",
    "target": "JUN 12, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Chicago",
    "order": 6
  },
  {
    "month": "July",
    "city": "Cleveland",
    "state": "OH",
    "target": "JUL 24, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Detroit",
    "order": 7
  },
  {
    "month": "August",
    "city": "Portland",
    "state": "OR",
    "target": "AUG 28, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Seattle",
    "order": 8
  },
  {
    "month": "September",
    "city": "Baltimore",
    "state": "MD",
    "target": "SEP 25, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Philadelphia",
    "order": 9
  },
  {
    "month": "October",
    "city": "Boston",
    "state": "MA",
    "target": "OCT 23, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "New York",
    "order": 10
  },
  {
    "month": "November",
    "city": "San Diego",
    "state": "CA",
    "target": "NOV 13, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "Los Angeles",
    "order": 11
  },
  {
    "month": "December",
    "city": "Baton Rouge",
    "state": "LA",
    "target": "DEC 19, 2027",
    "backup": "NOT YET OPEN",
    "status": "SELL-OUT UNLOCK CANDIDATE",
    "active": false,
    "conditional": true,
    "unlockOf": "New Orleans",
    "order": 12
  }
];
